export const API_URL = process.env.REACT_APP_URL
export const productName = process.env.REACT_APP_APPNAME || "Xpanse"
export const companyName =
  process.env.REACT_APP_COMPANY || "Xpanstech Solutions Pvt Ltd"
export const appName = productName
export const IMAGE_URL = (
  process.env.REACT_APP_IMAGE_URL ||
  process.env.REACT_APP_URL ||
  ""
)
  .replace(/\/api\/?$/, "")
  .replace(/\/$/, "")

/** Join public asset host with a stored path; never emit "...comundefined". */
export const assetUrl = (path) => {
  if (path == null || path === "") return ""
  const value = String(path).trim()
  if (!value || value === "undefined" || value === "null") return ""
  if (/^https?:\/\//i.test(value) || value.startsWith("data:")) return value
  if (!IMAGE_URL) return value.startsWith("/") ? value : `/${value}`
  return `${IMAGE_URL}${value.startsWith("/") ? value : `/${value}`}`
}

export const AppConfig = {
  API_URL,
  IMAGE_URL,
  appName,
  productName,
  companyName,
  assetUrl,
}
